import type { Serv_ServerRequestMapping, Serv_ServerResponseMapping } from './Serv.types'
import { type Serv_HttpRequestOptions, Serv_httpRequestWithOption } from './Serv.httpRequest'
import { route as proxyRoute } from '../../../server/http/websocket/proxy.no-deps'
import { Serv_respondsToPing } from './Serv.ping'

export async function isOnline() {
    return Serv_respondsToPing()
}

export async function Serv_send<K extends keyof Serv_ServerRequestMapping>(
    method: K,
    sendData: Serv_ServerRequestMapping[K],
    opts: Serv_HttpRequestOptions = {}
): Promise<Serv_ServerResponseMapping[K]> {
    return Serv_httpRequestWithOption(opts)(proxyRoute, { params: { method }, body: sendData }).then(
        (response: { body: Serv_ServerResponseMapping[K] }) => {
            return response.body
        }
    )
}
